import { useProduct as useProductOriginal } from '@shopware/composables'
import { type Ref, computed } from 'vue'
import type { Schemas } from '#shopware'
import { sortProductMedia } from '#imports'

export function useProduct(
    product?: Ref<Schemas['Product']> | Schemas['Product'],
    configurator?: Ref<Schemas['PropertyGroup'][]> | Schemas['PropertyGroup'][]
) {
    const originalReturn = useProductOriginal(product, configurator)

    // Wrap the product ref to sort media by position
    const sortedProduct = computed(() => {
        const productValue = originalReturn.product.value

        return {
            ...productValue,
            media: sortProductMedia(productValue?.media)
        }
    })

    return {
        ...originalReturn,
        product: sortedProduct
    }
}
